// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xKjIP{align-items:center;height:100%;width:auto;min-width:fit-content;box-sizing:border-box;margin:16px}@media(orientation: portrait){.xKjIP{position:absolute;top:0;height:auto;width:auto;min-height:35%;min-width:80%;padding:0 16px}}.xKjIP .Jg3v5{padding:12px;box-shadow:none}.xKjIP .nKzQ1{display:flex;flex-direction:column;align-items:center;height:100%;width:100%;padding-bottom:64px}.xKjIP .nKzQ1 .VlC00{flex:1;position:relative;width:100%;height:100%;padding-bottom:200px}.xKjIP .nKzQ1 .VlC00 .O28Lu{aspect-ratio:8/5;border-radius:8px;overflow:hidden}.xKjIP .nKzQ1 .oRgrL{position:absolute;bottom:0;left:0;right:0;padding-top:16px;height:200px}.xKjIP .nKzQ1 .oRgrL .DekBl{width:164px;height:230px}.xKjIP .nKzQ1 .oRgrL .DekBl .Xy271{pointer-events:none}.xKjIP .nKzQ1 .oRgrL .DekBl .I_BWA{border-radius:8px;position:relative;width:164px;height:216px;text-align:left;overflow:hidden;box-shadow:none;border:2px solid transparent;transition:border-color .2s ease}.xKjIP .nKzQ1 .oRgrL .DekBl .I_BWA:hover,.xKjIP .nKzQ1 .oRgrL .DekBl .I_BWA.xpVtl{border-color:#6942f8}.xKjIP .nKzQ1 .oRgrL .DekBl .I_BWA .dAwCy{padding:0 8px}.xKjIP .nKzQ1 .oRgrL .DekBl .I_BWA .G1Utk{position:absolute;bottom:8px;left:0;right:0;padding:0 8px;display:flex;justify-content:space-between;align-items:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"TutorialVideosModal": `xKjIP`,
	"modalTitle": `Jg3v5`,
	"modalContent": `nKzQ1`,
	"modalMediaWrapper": `VlC00`,
	"responsivePlayer": `O28Lu`,
	"modalVideosSliderContainer": `oRgrL`,
	"VideoItemContainer": `DekBl`,
	"thumbnail": `Xy271`,
	"VideoItemCard": `I_BWA`,
	"played": `xpVtl`,
	"videoTitle": `dAwCy`,
	"durationRow": `G1Utk`
};
export default ___CSS_LOADER_EXPORT___;
